import { BaseError } from './baseError';

export class ApiError extends BaseError {
    public readonly statusCode: number;

    constructor(
        statusCode: number,
        message: string,
        originalError?: Error | unknown,
    ) {
        super(message, originalError);
        this.statusCode = statusCode;
    }

    override getDetails(): Record<string, string> {
        const baseDetails = super.getDetails();
        return {
            ...baseDetails,
            statusCode: this.statusCode.toString(),
        };
    }
}
